"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _locale = require("../locale");

var _func = require("../utils/func");

var _proptypes = require("../utils/proptypes");

var _styles = require("../styles");

var _fixedAuto = _interopRequireDefault(require("./fixedAuto"));

var _Datum = _interopRequireDefault(require("../Datum"));

var _Spin = _interopRequireDefault(require("../Spin"));

var _resizable = _interopRequireDefault(require("./resizable"));

var _hidable = require("../hoc/hidable");

var _SeperateTable = _interopRequireDefault(require("./SeperateTable"));

var _SimpleTable = _interopRequireDefault(require("./SimpleTable"));

var _Tr = require("./Tr");

var _Tbody = require("./Tbody");

var _select = _interopRequireDefault(require("./select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ResizeSeperateTable = (0, _resizable.default)(_SeperateTable.default);
var ResizeSimpleTable = (0, _resizable.default)(_SimpleTable.default);

var RadioWrapper = function RadioWrapper(Origin) {
  return function (props) {
    return (// eslint-disable-next-line react/prop-types
      _react.default.createElement(Origin, _extends({}, props, {
        distinct: true,
        limit: props.radio ? 1 : 0
      }))
    );
  };
};

var Table =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Table, _Component);

  function Table(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      scrollLeft: 0,
      scrollRight: 0
    };
    _this.bindTable = _this.bindTable.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Table.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var datum = this.props.datum;
    datum.dispatch(_Tr.ROW_HEIGHT_UPDATE_EVENT);
    datum.dispatch(_Tbody.RENDER_COL_GROUP_EVENT);
  };

  _proto.getRowsInView = function getRowsInView() {
    var _this$props = this.props,
        rowsInView = _this$props.rowsInView,
        data = _this$props.data,
        fixed = _this$props.fixed;
    var dataLength = data.length;
    if (rowsInView <= 0 || rowsInView > dataLength || fixed === 'x') return dataLength;
    return parseInt(rowsInView, 10);
  };

  _proto.bindTable = function bindTable(el) {
    var bindWrapper = this.props.bindWrapper;
    this.table = el;
    if (el && bindWrapper) bindWrapper(el);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        striped = _this$props2.striped,
        bordered = _this$props2.bordered,
        size = _this$props2.size,
        hover = _this$props2.hover,
        height = _this$props2.height,
        columns = _this$props2.columns,
        value = _this$props2.value,
        children = _this$props2.children,
        empty = _this$props2.empty,
        data = _this$props2.data,
        style = _this$props2.style,
        fixed = _this$props2.fixed,
        width = _this$props2.width,
        loading = _this$props2.loading,
        verticalAlign = _this$props2.verticalAlign,
        columnResizable = _this$props2.columnResizable,
        events = _this$props2.events,
        others = _objectWithoutPropertiesLoose(_this$props2, ["striped", "bordered", "size", "hover", "height", "columns", "value", "children", "empty", "data", "style", "fixed", "width", "loading", "verticalAlign", "columnResizable", "events"]);

    var _this$state = this.state,
        scrollLeft = _this$state.scrollLeft,
        scrollRight = _this$state.scrollRight;
    var className = (0, _classnames.default)((0, _styles.tableClass)('_', size, hover && 'hover', bordered && 'bordered', fixed && 'fixed', scrollLeft > 0 && 'left-float', scrollRight < 0 && 'right-float', "vertical-" + verticalAlign, columnResizable && 'resize', others.sticky && 'sticky'), this.props.className);

    var props = _objectSpread({}, others, {
      children: children,
      fixed: fixed,
      rowsInView: this.getRowsInView(),
      loading: loading,
      height: height,
      width: width,
      data: data,
      columns: columns,
      striped: striped,
      bordered: bordered,
      columnResizable: columnResizable
    });

    var isEmpty = (!data || data.length === 0) && !children;
    var useSeparate = fixed && !isEmpty;
    var ResizeSepTable = columnResizable ? ResizeSeperateTable : _SeperateTable.default;
    var ResizeSimTable = columnResizable ? ResizeSimpleTable : _SimpleTable.default;
    var RenderTable = useSeparate ? ResizeSepTable : ResizeSimTable;
    var newStyle = Object.assign({}, style);
    if (height) newStyle.height = height;
    if (useSeparate && !newStyle.height) newStyle.height = '100%';
    if (loading) newStyle.overflow = 'hidden';
    return _react.default.createElement("div", _extends({
      className: className,
      ref: this.bindTable,
      style: newStyle
    }, events), _react.default.createElement(RenderTable, props), loading && _react.default.createElement("div", {
      className: (0, _styles.tableClass)('loading')
    }, typeof loading === 'boolean' ? _react.default.createElement(_Spin.default, {
      size: 40
    }) : loading), isEmpty && _react.default.createElement("div", {
      className: (0, _styles.tableClass)('empty')
    }, _react.default.createElement("span", null, empty || (0, _locale.getLocale)('noData'))));
  };

  return Table;
}(_component.Component);

Table.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'size', 'type', 'keygen'), {
  bordered: _propTypes.default.bool,
  children: _propTypes.default.any,
  columns: _propTypes.default.array,
  data: _propTypes.default.array,
  empty: _propTypes.default.any,
  fixed: _propTypes.default.oneOf(['x', 'y', 'both']),
  height: _propTypes.default.number,
  hover: _propTypes.default.bool,
  loading: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool]),
  rowsInView: _propTypes.default.number,
  striped: _propTypes.default.bool,
  verticalAlign: _propTypes.default.oneOf(['top', 'middle']),
  width: _propTypes.default.number,
  columnResizable: _propTypes.default.bool,
  bindWrapper: _propTypes.default.func
});
Table.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  hover: true,
  rowsInView: 20,
  verticalAlign: 'top',
  columns: []
});

var _default = (0, _func.compose)(RadioWrapper, _Datum.default.hoc({
  bindProps: ['disabled', 'format', 'prediction', 'limit', 'distinct'],
  ignoreUndefined: true,
  setValueType: null,
  pure: false
}), _fixedAuto.default, _hidable.consumer, _select.default)(Table);

exports.default = _default;